export default "__VITE_ASSET__QKEoiR9Z__"